'use strict';exports.__esModule = true;var REGISTRATION_FIELDS = {
  EMAIL: 'email',
  PHONE: 'phone',
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  PASSWORD: 'password',
  REPEAT_PASSWORD: 'repeat_password',
  IS_AGENT_CHECKBOX: 'isAgentCheckbox',
  COMPANY_NAME: 'company_name',
  LICENSE_NUMBER: 'license_number',
  COUPON: 'coupon',
  LOGO: 'logo',
  AGREE: 'agree',
  CODE: 'code' };exports.default =


REGISTRATION_FIELDS;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/RegistrationContainer/constants.js
// module id = 3015
// module chunks = 0